import React from "react";
import {withNamespaces} from "react-i18next";

const InputFilter = ({ t, column: {filterValue, setFilter}}) => {

    return (
        <input
            className="form-control"
            value={filterValue || ""}
            onChange={e => {
                setFilter(e.target.value || undefined)
            }}
            placeholder={t('column-find')}
        />
    )
};
export default withNamespaces()(InputFilter);
